import React from 'react';
import ProjectOrdersTable from './ProjectOrdersTable/ProjectOrdersTable';


const ProjectOrdersPage = () => {
  return (
    <div>
      <ProjectOrdersTable />
    </div>
  );
};

export default ProjectOrdersPage;
